

$(function(){
    var Opened = false;
    $("body").on("click","[data-toggle='toggle-qr']",function(e){
        e.preventDefault();
        $($(this).attr("href")).fadeIn(100);
        Opened = true;
        return false;
    });

    $("body").on("click", ".qr-code-toggle-cls", function(e){
        e.preventDefault();
        return false;
    });

    $("body").on("click", ".qr-code-toggle-cls i", function(e){
        e.preventDefault();
        $($(this).parent().parent().find("a").attr("href")).fadeOut(100);
        Opened = false;
        return false;
    });

    $("body").on("click",function(e){
       if(Opened) {
           e.preventDefault();
           $($(this).attr("href")).fadeOut(100);
           Opened = false;
           return false;
       }
    });

    $(".contet-qr-code").each(function(){
        var par = $(this).parent().find(".toggle-label a").text();

        $(this).parent().find(".toggle-label a").on("click", function (e) {
            e.preventDefault();
            const el = document.createElement('textarea');
            el.value = $(this).text();
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            SuccessMessage(LANGUAGE['clipboard-copied']);
            $("#qr-code-toggle").fadeOut(100);
            Opened = false;
            return false;
        });

        var qrCode=new window.QRCode(this,{
            text:par,
            width: 640,
            height: 640,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : 0
        });

    });
});